<template>
  <div>
    <div v-if="loading">
      <Loading/>
    </div>
    <div v-if="!loading">
      <Disposals v-if="isDriver" v-bind:bookings="getDriverDisposals"> </Disposals>
    </div>
  </div>
</template> 

<script>
import Disposals from "@/components/Disposals";
import Loading from "@/components/Loading";
export default {
  name: 'DriverWasteDisposals',
  components: { Disposals, Loading },
  data() {
    return {
    }
  },
  computed: {
    loading() {
      return this.$store.getters['admin/getLoading'];
    },
    isDriver() {
      return this.$store.getters['auth/isDriver'];
    },
    user() {
      return this.$store.getters['auth/getUser'];
    },
    bookingError() {
      return this.$store.getters['admin/getBookingError'];
    },
    getDriverDisposals(){
      return this.$store.getters['admin/getDriverDisposals'];
    },
    query(){
      let driverQuery = {
        driverId: this.$store.getters['auth/getUser'].id,
        query: this.$store.getters['admin/getDriverDisposalQuery']
      }
      return driverQuery;
    }
  },
  watch: {
    bookingError(error) {
      if (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    if(this.getDriverDisposals.length === 0){
      this.$store.dispatch('admin/fetchDriverDisposals', this.query);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>